import {
  AbsenceReasonResponse,
  AbsenceReasonResponseItem
} from '@/types/service-response'

export class AbsenceReason {
  private constructor (
    readonly id: number,
    readonly description: string,
    readonly language: number,
  ) {}

  public static createListFromResponse (data: AbsenceReasonResponse): Array<AbsenceReason> {
    return data.map((item: AbsenceReasonResponseItem) => {
      return new AbsenceReason(
        item.ID,
        item.Bezeichnung,
        item.Sprache
      )
    })
  }

}
